<script>
import DesktopLayout from '@layouts/desktop.vue';
import MobileLayout from '@layouts/mobile.vue';
import Sidebar from '@components/profile/sidebar.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  page: {
    title: 'Profile',
    meta: [{ name: 'description', content: 'The Profile page.' }],
  },
  components: {
    Sidebar,
    DesktopLayout,
    MobileLayout,
  },
  data() {
    return {
      hideRouterView: true,
    };
  },
  mixins: [breakpointsMixin],
  methods: {},
};
</script>

<template>
  <div>
    <DesktopLayout v-if="isDesktopView">
      <b-container id="profile" fluid>
        <div
          transition
          v-if="isDesktopView || (!isDesktopView && hideRouterView)"
          :class="['col-4', { full: !isDesktopView && hideRouterView, isMobile: !isDesktopView }]"
        >
          <Sidebar :isMobile="!isDesktopView" @hide-router-view="hideRouterView = false" />
        </div>
        <div
          transition
          v-if="isDesktopView || (!isDesktopView && !hideRouterView)"
          :class="['col sub-route-container', { full: !isDesktopView && !hideRouterView, isMobile: !isDesktopView }]"
        >
          <router-view @hide-router-view="hideRouterView = true" :isMobile="!isDesktopView" :hideRouterView="hideRouterView">
          </router-view>
        </div>
      </b-container>
    </DesktopLayout>

    <MobileLayout v-if="!isDesktopView">
      <b-container id="profile" fluid>
        <div
          transition
          v-if="isDesktopView || (!isDesktopView && hideRouterView)"
          :class="['col-4', { full: !isDesktopView && hideRouterView, isMobile: !isDesktopView }]"
        >
          <Sidebar :isMobile="!isDesktopView" @hide-router-view="hideRouterView = false" />
        </div>
        <div
          transition
          v-if="isDesktopView || (!isDesktopView && !hideRouterView)"
          :class="['col sub-route-container', { full: !isDesktopView && !hideRouterView, isMobile: !isDesktopView }]"
        >
          <router-view @hide-router-view="hideRouterView = true" :isMobile="!isDesktopView" :hideRouterView="hideRouterView">
          </router-view>
        </div>
      </b-container>
    </MobileLayout>
  </div>
</template>

<style lang="scss">
// stylelint-disable no-descending-specificity
#profile {
  // position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-height: calc(100vh - 13.5rem);
  padding: 0;
  .col-4 {
    max-width: 40rem;
    padding: 0;
    &.isMobile {
      &.full {
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        .sidebar-container {
          border-right: unset;
          .option {
            margin-bottom: 0.3rem;
          }
        }
      }
    }
  }
  .sub-route-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    &.isMobile {
      &.full {
        padding-left: unset;
        padding-right: unset;
        .payment-block-container {
          padding-left: unset;
          padding-right: unset;
          .payment-list {
            padding-left: unset;
            padding-right: unset;
          }
        }
        .info-container {
          padding-left: unset;
          padding-right: unset;
          .avatar-container {
            flex-direction: column;
            margin-bottom: 1rem;
            button {
              width: fit-content;
              @media screen and (max-width: 500px) {
                align-self: center;
                width: 75%;
              }
            }
          }
          .submit {
            margin: auto;
            margin-top: 1rem;
            width: 84%;
          }
        }
        .sub-container {
          padding-left: unset;
          padding-right: unset;
          .buttons-container {
            flex-direction: column;
            div {
              align-items: center;
              flex-direction: column;
              width: 100%;
              button {
                width: 80%;
              }
              .change {
                margin-bottom: 1rem;
                margin-right: unset;
              }
            }
            .cancel {
              margin-top: 1rem;
            }
          }
        }
        .payment-container {
          padding-left: unset;
          padding-right: unset;
          .card-name {
            align-items: center;
            flex-direction: column;
            text-align: center;
            .nick-name {
              display: flex;
              justify-content: center;
            }
            .number {
              @extend .nick-name;
            }
          }
          .edit-btn {
            display: flex;
            justify-content: center;
            button {
              width: 80%;
            }
          }
          form {
            .edit {
              margin: auto;
              margin-top: 1rem;
              width: 80%;
            }
          }
        }
        .pw-container {
          .col-5 {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>
